module.exports = __webpack_public_path__ + "static/media/Calibri-Bold.8c8905b9.TTF";